import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const LockIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 8.33341V6.66675C5 3.90841 5.83333 1.66675 10 1.66675C14.1667 1.66675 15 3.90841 15 6.66675V8.33341"
        stroke="#475569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 15.4167C11.1509 15.4167 12.0837 14.4839 12.0837 13.3333C12.0837 12.1827 11.1509 11.25 10.0003 11.25C8.84973 11.25 7.91699 12.1827 7.91699 13.3333C7.91699 14.4839 8.84973 15.4167 10.0003 15.4167Z"
        stroke="#475569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.167 18.3333H5.83366C2.50033 18.3333 1.66699 17.4999 1.66699 14.1666V12.4999C1.66699 9.16659 2.50033 8.33325 5.83366 8.33325H14.167C17.5003 8.33325 18.3337 9.16659 18.3337 12.4999V14.1666C18.3337 17.4999 17.5003 18.3333 14.167 18.3333Z"
        stroke="#475569"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
